import constants from 'core/data-model/constants/values'
import { partnerApiHandlerHelper } from 'core/service-wrapper/partner-api/handler-request/service-handler-helper'
import { partnerApiRequest } from 'core/service-wrapper/partner-api/handler-request/service-request'
import { partnerApiUtils } from 'core/service-wrapper/partner-api/handler-request/service-utils'
import { getIdentityUser } from 'identity/selectors'
import * as commonCoverageSelector from 'quick-quote/product-common/coverage-plan/selectors'
import * as productSelectionSelector from 'quick-quote/product-selection/selectors'
import { store } from 'store'

/**
 * createProductPAService
 * @param productCommonService {ReturnType<import('./product-common').createProductCommonService>}
 */
export function createProductPACoveragePlanService(productCommonService) {
  function getAvailableOptionPlanPARider(state) {
    const selectedDisplay = productSelectionSelector.getSelectedDisplayProduct(state)
    if (selectedDisplay.category !== constants.PA) {
      return []
    }

    const products = productCommonService.getDisplayProductFromCache(selectedDisplay.code, { listAll: true })
    const availableRiders = productCommonService.getAvailableRidersByDisplayProductCode(selectedDisplay.code)

    return products
      ?.map((product) => {
        if (product.riders.length && availableRiders && availableRiders[product.riders[0]]) {
          // prettier-ignore
          return availableRiders[product.riders[0]]
            .overrideFields
            .options[0]
            .values
            .find((value) => product.riders[0] === value.planCode)
        }
        return null
      })
      ?.filter((o) => o !== null)
      ?.reduce((acc, cur) => [...acc, cur], [])
  }

  async function resolveRiderOptionForPlan(displayProduct, rider) {
    const { modalFactor } = partnerApiUtils
    const state = store.getState()
    const user = getIdentityUser(state)

    const products = productCommonService.getDisplayProductFromCache(displayProduct.code, { listAll: true })
    const availableRiders = productCommonService.getAvailableRidersByDisplayProductCode(displayProduct.code)

    return await Promise.all(
      products
        .sort((o1, o2) => {
          return o1.basicPlanCode.localeCompare(o2.basicPlanCode)
        })
        .map(async (product) => {
          const paRider = availableRiders[product.riders[0]]
          // prettier-ignore
          const package_rider = paRider
            .overrideFields
            .options[0]
            .values
            .find((value) => product.riders[0] === value.planCode)

          const calPayload = await partnerApiHandlerHelper.createCalculatePayloadWithExpect(state, {
            basicPlan: {
              productRefName: product.productRefName,
              basicPlanCode: product.basicPlanCode,
              classCode: 'S',
              modalFactor: modalFactor.toSymbol(commonCoverageSelector.getSelectedModelFactorID(state)),
              basicSA: product.defaultSumAssured,
            },
            riders: [
              {
                riderCode: paRider.riderCode,
                riderSA: paRider.defaultSA,
              },
            ],
          })
          const calResult = await partnerApiRequest.calculateWithValidation(user, calPayload)
          if (calResult.riders[0].errors.length > 0) {
            return null
          }

          return {
            planCode: package_rider.planCode,
            name: package_rider.name,
            premium: calResult.totalPremium,
            package: package_rider.package,
          }
        })
        .filter((o) => o !== null)
        .reduce((acc, cur) => [...acc, cur], [])
    )
  }

  return {
    getAvailableOptionPlanPARider,
    resolveRiderOptionForPlan,
  }
}
